import React from 'react';
import { NavLink, Outlet, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const linkCls = ({ isActive }) =>
  `block px-4 py-3 text-sm font-light tracking-wide uppercase border-l-2 transition-colors ${
    isActive
      ? 'border-[#d94e47] text-black bg-white'
      : 'border-transparent text-gray-500 hover:text-black hover:bg-white'
  }`;

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#fafafa] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#f2f2f2] border-r border-gray-200 flex flex-col">
        <div className="p-6 border-b border-gray-200">
          <Link to="/" className="block">
            <p className="text-xs font-light tracking-[0.25em] text-gray-500 uppercase">smarch</p>
            <p className="text-lg font-light tracking-tight">Admin CMS</p>
          </Link>
        </div>

        <nav className="flex-1 py-4" data-testid="admin-nav">
          <NavLink to="/admin" end className={linkCls} data-testid="nav-dashboard">
            Tableau de bord
          </NavLink>
          <NavLink to="/admin/projects" className={linkCls} data-testid="nav-projects">
            Projets
          </NavLink>
          <NavLink to="/admin/news" className={linkCls} data-testid="nav-news">
            Actualités
          </NavLink>
          <NavLink to="/admin/philosophy" className={linkCls} data-testid="nav-philosophy">
            Philosophie
          </NavLink>
        </nav>

        <div className="p-6 border-t border-gray-200 text-xs font-light text-gray-500">
          <p className="mb-1 truncate" title={user?.email}>{user?.email}</p>
          <button
            onClick={onLogout}
            className="mt-2 text-[#d94e47] hover:underline"
            data-testid="admin-logout"
          >
            Se déconnecter
          </button>
          <div className="mt-4">
            <Link to="/" className="hover:underline" data-testid="link-to-public">
              → Voir le site public
            </Link>
          </div>
        </div>
      </aside>

      <main className="flex-1 p-10 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
